import { Component, OnInit } from '@angular/core';
import { FileModel, QResult } from '../../../../../models';
import { DocumentFor360, StageDocu360 } from '../../../../../models/formation/formation.model';
import { CoreService, FilesManagerService, HttpService } from '../../../../../services';
import { StageService } from '../../services/stage-modal.service';



@Component({
  selector: 'queoval-stage-doc360',
  templateUrl: './documents360.component.html',
  styleUrls: ['./documents360.component.css']
})
/*
* Composant pour l'affichage des documents dans la vue 360
*/
export class Documents360Component implements OnInit {

  // #region CONSTRUCTEUR
  constructor(
    public service: StageService,
    private http: HttpService,
    private indParam: CoreService,
    private fileService: FilesManagerService
  ) {}
  // #endregion
  
  // #region VARIABLES GLOBALES

  /** model global pour la gestion des documents */
  public model: StageDocu360;
  // #endregion

  // #region CYCLE DE VIE

  public ngOnInit(): void {
    this.model = new StageDocu360();
    this.ListenModeCursus();
  }
  
  // #endregion

  // #region FONCTIONS PUBLIQUES

  /**
   * télécharge le document au clique sur l'icone
   * @param document document sélectionné
   */
  public DownloadDocument(document: DocumentFor360): void {
    const modelDownload: FileModel = new FileModel();
    modelDownload.DownloadMode = 'PDFFROMIDENT';
    modelDownload.Ident = document.Ident;
    modelDownload.Name = document.Ident;
    modelDownload.DisplayName = document.Titre;
    modelDownload.Extension = 'pdf';

    //service pour le téléchargement du fichier
    this.fileService.downloadFile(modelDownload)
  }

  // #endregion

  // #region FONCTIONS PRIVES

  /**
   *  permet de savoir si le mode cursus est true ou false,
   *  grace à l'Observable isModeCursus qui est dans le service
   */
  private ListenModeCursus() {
    this.service.isModeCursus.subscribe((result: boolean) => {
      result ? this.InitCursusData() : this.InitData();
    })
  }

  /** fonction lancé pour récuperer la liste des documents */
  private InitData(): void {
    this.http.getHttp<QResult<StageDocu360>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/INIT_LIST_DOCUMENTS/${this.service.Stage.Ident}`)
      .subscribe((result: QResult<StageDocu360>) => {
        if (!result.HasError) {
          this.model.LstDocuments = result.Value.LstDocuments;
        }
      });
  }

  /** fonction lancé pour récuperer la liste des documents de tout les stage du cursus */
  private InitCursusData(): void {
    this.http.getHttp<QResult<StageDocu360>>(`${this.indParam.AppParams.apiUrl}api/Stage/Vue360/INIT_LIST_DOCUMENTS_CURSUS/${this.service.Stage.Ident}`)
      .subscribe((result: QResult<StageDocu360>) => {
        if (!result.HasError) {
          this.model.LstDocuments = result.Value.LstDocuments;
        }
      });
  }
  // #endregion
}

